module.exports = __webpack_public_path__ + "img/OpenEngageWhiteLogoWithText.0047d13.svg";